export type AiLeadEmailMessageResponseBody = {
  id: string;
  to: string;
  from: string;
  subject: string;
  body: string;
  receivedAt: string;
  aiSentiment?: string | null;
  aiLeadQuality?: string | null;
  aiReasoning?: string | null;
  aiSummary?: string | null;
};
export type GetAiLeadEmailMessageApiResponse = /** status 200  */ AiLeadEmailMessageResponseBody;
export type GetAiLeadEmailMessageApiArg = {
  id: string;
};

export type RetryAiLeadEmailMessageApiResponse = /** status 204  */ void;
export type RetryAiLeadEmailMessageApiArg = {
  emailMessageId: string;
};

export type ConfirmAiLeadEmailMessageApiResponse = /** status 204  */ void;
export type ConfirmAiLeadEmailMessageApiArg = {
  emailMessageId: string;
};
export type FailAiLeadEmailMessageApiResponse = /** status 204  */ void;
export type FailAiLeadEmailMessageApiArg = {
  emailMessageId: string;
};
export type GetAiLeadSettingsApiArg = void;
export type UpdateAiLeadSettingsApiResponse = unknown;

export type AutomatedCommunicationMode = 'BUSINESS_CASE_ONLINE_OFFER' | 'INTEREST_OFFER';

export type AutomatedCommunicationResponseBody = {
  enabled: boolean;
  mode: AutomatedCommunicationMode;
  emailCredentialsId: string | null;
  businessCaseOnlineOfferPrompt: string | null;
  interestOfferPrompt: string | null;
};

export type AutomatedCommunicationRequestBody = AutomatedCommunicationResponseBody;

export type GetAiLeadSettingsApiResponse = {
  enabled: boolean;
  allowedEmailAddresses: string[];
  processingEmailAddress: string;
  defaultBranchId: string | null;
  whatsAppEnabled: boolean;
  automatedCommunication: AutomatedCommunicationResponseBody;
};
export type UpdateAiLeadSettingsApiArg = {
  enabled: boolean;
  allowedEmailAddresses: string[];
  defaultBranchId: string | null;
  /** Null (or omitted) keeps the current WhatsApp setting unchanged. */
  whatsAppEnabled?: boolean | null;
  automatedCommunication?: AutomatedCommunicationRequestBody | null;
};
